import '../stylesheets/notfound.css';

export default function NotFoundPage() {
  return (
    <div className="NotFoundPage wrapper">
        <img src="/images/partials/not-found.jpg" alt="not-found" />
    </div>
  )
}
